/* hs-eslint ignored failing-rules */

/* eslint-disable no-bitwise */
'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import { EMPTY_ARRAY } from 'DesignData/lib/array';
import { EMPTY_OBJECT } from 'DesignData/lib/object';
import { COS_INDEX_CONNECTIONS_FETCH_FOR_LAYOUT_WIDGETS } from 'DesignData/actions/ActionTypes';
/*

The COS Index treats widget ids as universally unique - they're not.
But since that is the case with the index we are not scoping widget
data to a layout here.

{
  byWidget: {
    [widgetId]: {
      isFetching: false,
      content: {
        // Sorted by `updated` DESC
        list: [contentId],
        data: {
          [contentId]: {
            contentId,
            widgetId,
            cosIndexModuleField,
            label,
            updated,
          },
        },
      },
    },
  },
}

*/

const EMPTY_CONTENT_STATE = SeamlessImmutable({
  list: [],
  data: {}
});
const byWidgetReducers = combineReducers({
  isFetching(state = false, action) {
    switch (action.type) {
      case COS_INDEX_CONNECTIONS_FETCH_FOR_LAYOUT_WIDGETS:
        {
          const {
            connections,
            error
          } = action;
          return !(connections || error);
        }

      default:
        return state;
    }
  },

  error(state = null, action) {
    switch (action.type) {
      case COS_INDEX_CONNECTIONS_FETCH_FOR_LAYOUT_WIDGETS:
        return action.error || null;

      default:
        return state;
    }
  },

  content(state = EMPTY_CONTENT_STATE, action) {
    switch (action.type) {
      case COS_INDEX_CONNECTIONS_FETCH_FOR_LAYOUT_WIDGETS:
        {
          const {
            connections,
            widgetId,
            widgetIdToCosIndexId
          } = action;

          if (!(widgetId && connections && widgetIdToCosIndexId)) {
            return state;
          }

          const cosIndexId = widgetIdToCosIndexId[widgetId];
          const contents = connections && connections[cosIndexId] || EMPTY_ARRAY;
          if (!contents.length) return EMPTY_CONTENT_STATE;
          const newState = {
            list: [],
            data: {}
          };
          contents.forEach(content => {
            const {
              model
            } = content || EMPTY_OBJECT;
            if (!model) return;
            newState.data[model.id] = {
              label: model.label,
              id: model.id,
              categoryId: model.categoryId,
              updated: model.updated,
              publishedUrl: model.publishedUrl,
              currentState: model.currentState
            }; // Sort by `updated` DESC

            {
              const idx = newState.list.findIndex(id => {
                const {
                  updated
                } = newState.data[id];
                return model.updated >= updated;
              });

              if (!~idx) {
                newState.list.push(model.id);
              } else {
                newState.list.splice(idx, 0, model.id);
              }
            }
          });
          return newState.list.length ? SeamlessImmutable(newState) : EMPTY_CONTENT_STATE;
        }

      default:
        return state;
    }
  }

});

function byWidget(state = EMPTY_OBJECT, action) {
  switch (action.type) {
    case COS_INDEX_CONNECTIONS_FETCH_FOR_LAYOUT_WIDGETS:
      {
        const {
          widgetIds
        } = action;
        if (!widgetIds) return state;
        widgetIds.forEach(widgetId => {
          const childState = byWidgetReducers(state[widgetId], Object.assign({}, action, {
            widgetId
          }));
          state = SeamlessImmutable.set(state, widgetId, childState);
        });
        return state;
      }

    default:
      return state;
  }
}

function byLayout(state = EMPTY_OBJECT, action) {
  switch (action.type) {
    case COS_INDEX_CONNECTIONS_FETCH_FOR_LAYOUT_WIDGETS:
      {
        const {
          layoutId
        } = action;
        const path = [layoutId, 'byWidget'];
        const childState = SeamlessImmutable.getIn(state, path);
        state = SeamlessImmutable.setIn(state, path, byWidget(childState, action));
        return state;
      }

    default:
      return state;
  }
}

export default combineReducers({
  byLayout
});